import { useQuery } from "@tanstack/react-query";
import { Dropdown } from "antd";
import "./title-page-fillers-dropdown.scss";
import { useCoordinator } from "@shared/lib/hooks";
import { fallbackString } from "@shared/utils";
import { projectQueries } from "../../../project/api/project.queries";
import { journalsQueries } from "../../api/journals.queries";

type SectionType = "sectionOne" | "sectionTwo" | "sectionThree" | "sectionFour";

interface TitlePageFillersDropdownProps {
  text?: string;
  sectionType?: SectionType;
  sectionId?: string;
}

export const TitlePageFillersDropdown = ({
  text = "Обратитесь к заполняющему Титульного листа.",
  sectionType,
  sectionId,
}: TitlePageFillersDropdownProps) => {
  const { projectId, titleId } = useCoordinator() as {
    projectId: string;
    titleId?: string;
  };

  const isSectionMode = Boolean(sectionType && sectionId);

  const responsibleQuery = isSectionMode && titleId
    ? {
        ...(journalsQueries.getResponsibleList(titleId) as any),
        enabled: !!titleId,
      }
    : {
        queryKey: ["title-page-fillers", "responsible", "empty"],
        queryFn: async () => null,
        enabled: false,
      };

  const { data: responsible } = useQuery<any>(responsibleQuery as any);

  const projectAdminsQuery = projectQueries.getProjectAdmin({ projectId });
  const { data: admins } = useQuery<any>({
    ...(projectAdminsQuery as any),
    enabled: !!projectId,
  });

  const mapInputters = (inputters: any[] | undefined) => {
    if (!Array.isArray(inputters)) return [];

    return inputters.map((item: any) => {
      const user = item?.userHistory || {};
      const roleInfo = user?.roleInfo || {};
      const companies = roleInfo?.userCompaniesHistory || [];
      const firstCompany = companies[0] || {};

      const fullName = `${user.userSurname ?? ""} ${user.userFirstName ?? ""} ${user.userMiddleName ?? ""}`.trim();
      const position = firstCompany.position || "";
      const companyName = firstCompany.shortName || "";

      return {
        name: fullName,
        role: position,
        company: companyName,
        email: user.userEmail,
      };
    });
  };

  const sectionInputters =
    isSectionMode && responsible
      ? mapInputters((responsible as any)?.inputters)
      : [];

  const adminFillers =
    (admins?.userInfo || []).map((item: any) => {
      const fullName = `${item.userSurname} ${item.userFirstName} ${item.userMiddleName}`;
      const firstCompany = item.userCompanies?.[0];
      const position = firstCompany?.position || "";
      const companyName = firstCompany?.shortName || "";

      return {
        name: fullName,
        role: position,
        company: companyName,
        email: item.userEmail,
      };
    }) || [];

  let fillers: Array<{ name: string; role: string; company: string; email: string }> = [];

  if (sectionInputters.length > 0) {
    fillers = sectionInputters;
  } else if (adminFillers.length > 0) {
    fillers = adminFillers;
  } else {
    fillers = [];
  }

  const dropdownContent = (
    <div className="title-page-fillers-list">
      {fillers.map((filler: any) => (
        <div key={filler.email} className="title-page-filler-item">
          <div className="filler-name">{fallbackString(filler.name)}</div>
          <div className="filler-role">{fallbackString(filler.role)}</div>
          <div className="filler-email">{fallbackString(filler.email)}</div>
        </div>
      ))}
    </div>
  );

  return (
    <Dropdown
      overlay={dropdownContent}
      trigger={["click"]}
      placement="top"
      align={{ offset: [0, 0] }}
    >
      <span className="title-page-fillers-link">{text}</span>
    </Dropdown>
  );
};
